import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { DynamicScriptLoaderServiceService } from '../../_services/dynamic-script-loader-service.service';
import { AuthenicationService } from '../../_services/authenication.service';
import { DoctorService } from '../../_services/doctor.service';
import {PatientsService } from "../../_services/patients.service";
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';

declare var $: any;
import * as moment from 'moment';
import {PricesService} from "../../_services/prices.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.css']
})
export class AppointmentsComponent implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;

  id: string;
  code: string;
  date: string;
  status = this.route.snapshot.params.status;
  returnUrl: string;
  href: string;
  url: string;
  appointments: any[] = [];
  total: any[] = [];
  today : any;

  page = 1;
  size = 10;
  count = 0;
  totalS: any;
  searchValue = '';

  // tslint:disable-next-line:max-line-length
  constructor(private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private doctorservice: DoctorService, private patientsservice: PatientsService ,private toaster: ToasterService, private pricesService: PricesService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // DynamicScriptLoaderServiceService.adminScripts();
    // DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom.js');
    this.userdetaild = this.authenicationService.userDetails();
    this.href = this.router.url;
    this.url = this.router.url.split('/')[2];

   if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
     this.router.navigate(['/']);
   }

    this.today = moment(new Date()).format("YYYY-MM-DD");

    this.route.params.subscribe(routeParams => {
      if(routeParams.status == 'all'){
        this.code = '';
        this.date = '';
      }
      if(routeParams.status == 'active'){
        this.code = '0';
        this.date = this.today;
      }
      if(routeParams.status == 'cancel'){
        this.code = '2';
        this.date = '';
      }

      const payload = {
        status: this.code,
        date: this.date,
        value: this.searchValue,
      };
      this.changeParam(payload);
    });

    this.id = this.userdetaild['_id'];




    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }


    // console.log(payload);
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';



  }

  changeParam(payload){
    this.getAllAppointment(this.page,this.size,payload);
  }

  getAllAppointment(page, size, payload) {
    this.doctorservice.listAllAppointmentPagination(page, size, payload)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Appointments', data.ResponseMessage);
            this.appointments = data.DoctorAppointment;
            this.count = data.total;
            this.createRange(data.total);

            // setTimeout( () => {
            //   $(function () {
            //     $('#example').DataTable();
            //   });
            // }, 1000);
          } else {
            // this.toaster.showError('Appointments', data.ResponseMessage);
            this.appointments = [];
            this.count = 0;
            this.createRange(0);
            // setTimeout( () => {
            //   $(function () {
            //     $('#example').DataTable();

            //   });
            // }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          // this.toaster.showError('Doctor', error);
          this.createRange(0);
          this.count = 0;
           this.appointments = [];
          // setTimeout( () => {
          //   $(function () {
          //     $('#example').DataTable();
          //   });
          // }, 1000);
        });
  }

  // getPatientTotalAppointment(cid){
  //   const id = {
  //     clientid: cid
  //   };
  //
  //   this.patientsservice.getPatientAppointment(id)
  //     .subscribe(
  //       (data: any) => {
  //
  //         this.total.push(data.ClientAppointment.length);
  //
  //       }
  //     );
  //   return this.total;
  // }

  processPaymentRefund(payment_id,id) {
    if(confirm('Proceed with Refund')) {
      const payload = {
        payment_id: payment_id,
        id: id
      };
      this.pricesService.processPaymentRefund(payload)
        .subscribe(
          (data: any) => {
            if (data && data.ResponseCode === '200') {
              this.spinnerService.hide();
              //this.router.navigate([`/get-prices/${this.docid}`]);
            } else {
              this.spinnerService.hide();
              this.toaster.showError('Refund', data.ResponseMessage);
            }
          },
          error => {
            this.spinnerService.hide();
            this.toaster.showError('Refund', error);
          });
    }
  }

  processCancelPaymentRefund(payment_id,id) {
      const payload = {
        payment_id: payment_id,
        id: id
      };
      this.pricesService.processPaymentRefund(payload)
        .subscribe(
          (data: any) => {
            if (data && data.ResponseCode === '200') {
              this.spinnerService.hide();
              //this.router.navigate([`/get-prices/${this.docid}`]);
            } else {
              this.spinnerService.hide();
              this.toaster.showError('Refund', data.ResponseMessage);
            }
          },
          error => {
            this.spinnerService.hide();
            this.toaster.showError('Refund', error);
          });

  }


  sendEmail(payload) {
    this.spinnerService.show();
    const data = {
      sendData: payload
    };
      this.doctorservice.sendAppointmentCompletionEmail(data)
        .subscribe(
          (data: any) => {
            if (data && data.ResponseCode === '200') {
              this.spinnerService.hide();
              this.router.navigate([this.href]);
            } else {
              this.spinnerService.hide();
              this.toaster.showError('Email', data.ResponseMessage);
            }
          },
          error => {
            this.spinnerService.hide();
            this.toaster.showError('Email', error);
          });

  }


  sendFeedbackReminderEmail(id) {
    this.spinnerService.show();
    const data = {
      id: id
    };
      this.patientsservice.sendFeedbackReminderEmail(data)
        .subscribe(
          (data: any) => {
            if (data && data.ResponseCode === '200') {
              this.spinnerService.hide();
              this.router.navigate([this.href]);
            } else {
              this.spinnerService.hide();
              this.toaster.showError('Email', data.ResponseMessage);
            }
          },
          error => {
            this.spinnerService.hide();
            this.toaster.showError('Email', error);
          });

  }




  addUsedCode(payload) {
    this.doctorservice.addUsedCode(payload)
      .subscribe(
        (data: any) => {
          console.log('book',data);

        },
        error => {
          console.log('book',error);
        });
  }

  async checkPromoCode(data){
    return this.doctorservice.checkRemainingSession(data)
      .toPromise()
      .then(data => {
        if (data && data.ResponseCode === '200') {
          let total = data.Data.length;

          return data.Data[total - 1];
          //console.log(this.remainingData);
        }
        else{
          return undefined;
        }
      })
      .catch(err => {
        return undefined;
      })
  }

  async cancelAppointment(sData) {
    const userEmail = {
      user_email: sData['clientid']['users_email']
    };
    let remainingDatas = await this.checkPromoCode(userEmail);
    let str;
    let eligible;
    let date = sData['scheduleId']['date'];
    let time = sData['scheduleId']['start_time'];
    const dateFormat = "YYYY-MM-DD HH:mm:ss";
    let appdate = date + 'T' + time + ':00';
    let rightNow = moment().format(dateFormat);//now
    let appointmentDate = moment(appdate).format(dateFormat);

    const differenceInHours = moment(appointmentDate).diff(rightNow, 'hours');

    if (differenceInHours > 24) {
      str = 'Are you sure to Cancel Appointment';
      eligible = true;
    } else {
      str = 'You are trying to cancel the appointment within 24 hours. So, you will not receive any refund. Are you sure to Cancel Appointment.';
      eligible = false;
    }

    if (confirm(str)) {

      const payload = {
        appointmentId: sData._id,
        status: '2',
        cancel_date: rightNow,
        cancel_by: 'admin',
        is_eligible_for_refund: eligible
      };

      // console.log('message',payload);
      // return;

      this.doctorservice.updateStatus(payload)
        .subscribe(
          async (data: any) => {
            if (data && data.ResponseCode === '200') {

              if (eligible == true) {

                  if (remainingDatas != undefined) {
                    if (sData.coupon_code == remainingDatas.promocode) {
                      await this.refundSession(sData,remainingDatas);
                    }else{
                      await this.refundAmount(sData);
                    }
                  }else{
                    await this.refundAmount(sData);
                  }


              }else{
                alert('Appointment cancelled successfully');
              }

              // const sessionpayload = {
              //   clientid: this.usersid
              // };
              // this.getPatientSessions(sessionpayload);

            } else {
              console.log('Appointments', data.ResponseMessage);
            }
            // this.router.navigate([this.returnUrl]);
          },
          error => {
            console.log('Doctor', error.error.ResponseMessage);
          });
      }
    }

    async refundSession(sData,remainingDatas){
          const payload1 = {
            user_email: sData['clientid']['users_email'],
            promocode: remainingDatas.promocode,
            next_free_session_or_event: remainingDatas.next_free_session_or_event,
            remaining: remainingDatas.remaining,
            total_session_remaining: remainingDatas.total_session_remaining+1,
            type: remainingDatas.type
          };
          this.addUsedCode(payload1);
    }

    async refundAmount(sData){
      // console.log('message',sData);
      if(sData.coupon_code !== '') {
          if (sData.coupon_code == 'MP80') {
            if (sData.payment_status == 'captured') {
              if (sData.payment_details[0].id != undefined) {
                  this.processCancelPaymentRefund(sData.payment_details[0].id,sData._id);
              }
            }
          }
      }else{
        if (sData.payment_details[0].id != undefined) {
            this.processCancelPaymentRefund(sData.payment_details[0].id,sData._id);
        }
      }
    }
    createRange(number) {
      this.totalS = [];
      const num = (number / this.size);
      for (let i = 1; i <= Math.ceil(num); i++) {
        this.totalS.push(i);
      }
      return this.totalS;
    
    }
    
    pageChanged(event){
      this.page = event;
      const payload = {
        value: this.searchValue,
        status: this.code,
        date: this.date,
      };
    
      this.getAllAppointment(this.page, this.size, payload);
    }
    
    Sort(event){
        
      this.size = event.target.value;
      const payload = {
        value: this.searchValue,
        status: this.code,
            date: this.date,
      };
    
      this.getAllAppointment(this.page, this.size, payload);
    }
    
    search(event){
        
        // let strLeng = event.target.value.length;
    
        this.searchValue = event.target.value;
          const payload = {
            value: event.target.value,
            status: this.code,
            date: this.date,
          };
    
          this.getAllAppointment(this.page, this.size, payload);
    }

    getDate(date){
       return new Date(date).toLocaleDateString();
    }

    gettime(date){
      return new Date(date).toLocaleTimeString();
   }
}
